import { CommonModule } from '@angular/common';
import { Component, forwardRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DimensionsListenerDirective } from '@games/shared/game-dynamic-blocks/dimensions-listener.directive';

@Component({
    selector: 'ms-math-root',
    templateUrl: './math-root.component.html',
    styleUrls: ['./math-root.component.scss'],
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MathRootComponent),
            multi: true,
        },
    ],
    hostDirectives: [DimensionsListenerDirective]
})
export class MathRootComponent {

}
